'use client';

import React, { useEffect } from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);

type Props = {
  noLabel?: boolean;
};

const CurrentHQTime = ({ noLabel = false }: Props) => {
  const [time, setTime] = React.useState<string>('');

  useEffect(() => {
    const updateTime = () => {
      setTime(dayjs().tz('America/New_York').format('hh:mm a'));
    };

    updateTime();

    const interval = setInterval(updateTime, 1000 * 60); // Update every minute
    return () => clearInterval(interval); // Cleanup interval on unmount
  }, []);

  if (noLabel) {
    return <span>{time}</span>;
  }

  return <span>Current time at our headquarters — {time}</span>;
};

export default CurrentHQTime;
